import React, { FC, lazy, Suspense } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
  RouterProvider,
} from "react-router-dom";
import RestrictedRoute from "pages/PageRoot/components/RestrictedRoute";
import PrivateRoute from "./components/PrivateRoute";
import { ToastContainer } from "react-toastify";
import useIsMobile from "hooks/useIsMobile";
import { routes } from "config/routes";

const LogInPage = lazy(() => import("pages/LogInPage"));
const MainPage = lazy(() => import("pages/MainPage"));
const ClientsPage = lazy(() => import("pages/ClientsPage"));
const DriversPage = lazy(() => import("pages/DriversPage"));
const NewsletterPage = lazy(() => import("pages/NewsletterPage"));
const DiscountPage = lazy(() => import("pages/DiscountPage"));
const TariffsPage = lazy(() => import("pages/TariffsPage"));
const OrdersPage = lazy(() => import("pages/OrdersPage"));
const OrdersStatisticPage = lazy(() => import("pages/OrdersStatistic"));
const HistoryPage = lazy(() => import("pages/History"));

export const PageRoot: FC = () => {
  const isMobile = useIsMobile();

  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route
          path={routes.home}
          element={
            <PrivateRoute>
              <MainPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.signin.root}
          element={
            <RestrictedRoute>
              <LogInPage />
            </RestrictedRoute>
          }
        />
        <Route
          path={routes.orders.root}
          element={
            <PrivateRoute>
              <OrdersPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.ordersStatistic.root}
          element={
            <PrivateRoute>
              <OrdersStatisticPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.history.root}
          element={
            <PrivateRoute>
              <HistoryPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.drivers.root}
          element={
            <PrivateRoute>
              <DriversPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.clients.root}
          element={
            <PrivateRoute>
              <ClientsPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.tariffs.root}
          element={
            <PrivateRoute>
              <TariffsPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.discount.root}
          element={
            <PrivateRoute>
              <DiscountPage />
            </PrivateRoute>
          }
        />
        <Route
          path={routes.newsletters.root}
          element={
            <PrivateRoute>
              <NewsletterPage />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to={routes.home} replace />} />
      </>,
    ),
  );

  return (
    <Suspense fallback={null}>
      <RouterProvider router={router} />
      <ToastContainer limit={isMobile ? 2 : 3} icon={false} autoClose={5000} />
    </Suspense>
  );
};

export default PageRoot;
